/* 前端通用登录服务，wiki：https://gitlab.corp.youdao.com/webfront-public-service/common-login/tree/master */
/* eslint-disable */
export const YDLogin = function () {
  if (!process.env.BROWSER || !window._rlog) return null; // eslint-disable-line
  const [root, win, doc, ua, ec] = [window, window, document,
    navigator.userAgent, encodeURIComponent];
  const yd = root.yd || (root.yd = {});
  let requestParams = {}
  const getAccountServer = function () {
    const params = [];
    for (const k in requestParams) {
      params.push(`${k}=${ec(requestParams[k])}`);
    }
    const MAIN_URL = 'dict.youdao.com'
    return `${MAIN_URL}/login/acc/login?${params.join('&')}`;
  };

  /* 判断是否登录 */
  const isLogin = function () {
    if (document.cookie) {
      const cookies = document.cookie.split(';');
      const name = 'S_INFO='; // 通行证登录cookie
      const name3rd = /^DICT_LOGIN=[1357]\|/; // 登录cookie

      for (let i = cookies.length - 1; i >= 0; i--) {
        // trim
        const cookie = (cookies[i] || '').replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, '');
        if (cookie.substring(0, name.length) === (name) || name3rd.test(cookie)) {
          return true;
        }
        // console.log(cookie);
      }
      return false;
    }
    return false;
  };

  const loginWithUrl = function (Url) {
    const url = Url || document.URL;
    if (ua.match(/iPhone/i)
      && location.hash !== '#temporaryStyle'
      && (ua.indexOf('YDDict') !== -1
        || ua.indexOf('youdaodict') !== -1)
    ) {
      // iOS 客户端内登陆
      /**
       * ios下location.href部分情况无效
       *
       * http://stackoverflow.com/questions/6931914/what-s-the-difference-between-a-href-url-and-window-location-url-on-ios
       *
       * @luzhujun
       * @2015-4-2
       */
      // win.location.href = "dictapi://login:"+url;
      let node = doc.createElement('a');
      const pref = ua.indexOf('fanyiapp') !== -1 ? 'fanyiguanapi://login:' : 'dictapi://login:';
      node.href = pref + url;
      node.style.display = 'none';
      node.click();
      node = null;
    } else if (win.YoudaoDictAndroid !== undefined) {
      // Android 5.0+ 客户端登陆
      win.YoudaoDictAndroid.login(url);
    } else if (ua.match('windowspc')) {
      // PC客户端内登陆
      parent.pcLogin(url);
    } else if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      // 移动端
      win.location.href = `${yd.account.mobileUrl}#${ec(url)}`;
    } else {
      // web登陆
      win.location.href = `${yd.account.webUrl}#${ec(url)}`;
    }
  };

  /**
   *  处理一些登录 backurl 不带域名的情况, 如精品课的直接买课按钮
   */
  const pathAddHost = function (path) {
    const isUrl = /^https?:/.test(path)
    if (!isUrl) {
      return `${location.protocol}//${location.host}${path}`
    }
    return path
  }

  /**
   * 第三方登录
   * http://luna.corp.youdao.com/index.php?title=AccountServer/ThirdPart
   */
  const loginWithThird = function (tp, onsuccess) {
    requestParams.fr = 1;
    const urls = [
      'http://',
      getAccountServer(),
      `&app=web&product=DICT&tp=${tp}&ru=`,
      ec(pathAddHost(onsuccess)),
    ];

    if (top.location !== self.location) {
      // iframe
      win.open(urls.join(''));
    } else {
      location.href = urls.join('');
    }
  };

  /**
   *
   * login("url")
   *
   *
   * login("qq" , onsuccess)
   * login("weibo" , onsuccess)
   *
   * login("username" , "password" , "savelogin:boolean" , onsuccess , onerror)
   *
   */
  const sendRequest = function () {
    switch (arguments.length) {
      case 1:
        var arg0 = arguments[0];
        switch (arg0) {
          case "qq":
            loginWithThird("cqq");
            break;
          case "weibo":
            loginWithThird("tsina");
            break;
          case "weixin":
            if (/micromessenger/i.test(ua)) {
              loginWithThird("weixin-mp-yd");
            } else {
              loginWithThird("weixin");
            }
            break;
          default:
            loginWithUrl(arg0);
        }
        return;
      case 2:
        var arg1 = arguments[1];
        switch (arguments[0]) {
          case "qq":
            loginWithThird("cqq", arg1);
            return;
          case "weibo":
            loginWithThird("tsina", arg1);
            return;
          case "weixin":
            if (/micromessenger/i.test(ua)) {
              loginWithThird("weixin-mp-yd", arg1);
            } else {
              loginWithThird("weixin", arg1);
            }
            return;
          default:
            loginWithThird(arguments[0], arg1);
            return;
        }
        return;
      case 3:
      case 4:
        var arg1 = arguments[1];
        var arg2 = arguments[2];
        switch (arguments[0]) {
          case "qq":
            loginWithThird("cqq", arg1, arg2);
            return;
          case "weibo":
            loginWithThird("tsina", arg1, arg2);
            return;
          case "weixin":
            if (/micromessenger/i.test(ua)) {
              loginWithThird("weixin-mp-yd", arg1, arg2);
            } else {
              loginWithThird("weixin", arg1, arg2);
            }
            return;
          default:
            loginWithThird(arguments[0], arg1, arg2);
            return;
        }
      default:
        return;
    }
  };

  const login = function (username, password, savelogin) {
    requestParams = { cf: savelogin ? 7 : 3 }
    sendRequest.apply(this, arguments);
  };

  yd.account = {
    isLogin,
    login,
    callbackUrl: '',
  }
  return yd;
}



// WEBPACK FOOTER //
// ./src/core/commonLogin.js